/*
  Announcement bar close button.

  Dismissal is deliberately not persisted — no cookie, no storage. The team
  puts the bar up and takes it down from Site Options, and closing it only
  clears it for the current page view.
*/

class AnnouncementBar {
  constructor() {
    this.bar = document.querySelector('.js-announcement-bar');

    if (!this.bar) {
      return;
    }

    this.closeButton = this.bar.querySelector('.js-announcement-bar-close');

    if (!this.closeButton) {
      return;
    }

    this.init();
  }

  init() {
    this.closeButton.addEventListener('click', () => {
      this.bar.remove();

      // The bar lives inside the (optionally fixed) header, so removing it
      // changes the header height that navigation.js and search-highlight.js
      // measure — let them re-measure.
      window.dispatchEvent(new Event('resize'));
    });
  }
}

export default new AnnouncementBar();



// WEBPACK FOOTER //
// ./src/scripts/modules/announcement-bar.js